import styled from 'styled-components';
import { IStyledDescription } from './Card.interface';

export const StyledDescription = styled('div')<IStyledDescription>(
  ({ line }) => ({
    display: '-webkit-box',
    WebkitLineClamp: line,
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  }),
);
